import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-358cc6e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "customer-menu"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "customer-menu__badge"
}

import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import commons from '@/utils/Common'
import {
  fetchCustomerMenu,
  type CustomerMenuItem,
} from '@/utils/customerMenu'


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerMenu',
  emits: ["navigate", "logout"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { t, te } = useI18n()

const menuTree = ref<CustomerMenuItem[]>([])
const isLogin = ref(false)

const FALLBACK_ICONS = [
  'fa-solid fa-chart-pie',
  'fa-solid fa-list-ul',
  'fa-regular fa-address-card',
  'fa-solid fa-briefcase',
  'fa-solid fa-user-group',
  'fa-regular fa-credit-card',
]

const refreshLogin = () => {
  isLogin.value = !!commons.checkLogin()
}

const isVisibleItem = (item: CustomerMenuItem) => {
  if (item.slug === 'auth') return isLogin.value
  return !isLogoutItem(item)
}

const isLogoutItem = (item: CustomerMenuItem) => {
  const slug = String(item.slug || '').toLowerCase()
  const label = String(item.linkLabel || '').toLowerCase()
  return (
    slug === 'logout' ||
    slug === '/logout' ||
    slug.endsWith('/logout') ||
    label === 'text.logout' ||
    label.endsWith('.logout')
  )
}

const menuItems = computed(() => {
  if (!menuTree.value.length) return []

  const groupRoot = menuTree.value.find((root) => root.children?.length)
  if (groupRoot?.children?.length) {
    return groupRoot.children.filter(isVisibleItem)
  }

  return menuTree.value.filter(isVisibleItem)
})

const menuLabel = (linkLabel?: string) => {
  const label = String(linkLabel || '').trim()
  if (!label) return ''
  return te(label) ? t(label) : label
}

const getIcon = (item: CustomerMenuItem) => {
  if (item.icon) return item.icon
  const idx = Math.abs(Number(item.id) || 0) % FALLBACK_ICONS.length
  return FALLBACK_ICONS[idx]
}

const onItemClick = (item: CustomerMenuItem) => {
  if (isLogoutItem(item)) {
    emit('logout')
    return
  }
  emit('navigate', item.slug || '/')
}

const loadMenu = async () => {
  menuTree.value = await fetchCustomerMenu()
}

onMounted(async () => {
  refreshLogin()
  await loadMenu()
})

return (_ctx: any,_cache: any) => {
  return (menuItems.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.id,
            type: "button",
            class: "customer-menu__item",
            onClick: ($event: any) => (onItemClick(item))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(getIcon(item)),
              "aria-hidden": "true"
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(menuLabel(item.linkLabel)), 1),
            (item.badge)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(menuLabel(item.badge)), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})